import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Spacer, Heading, Text, Paragraph } from "@zillow/constellation";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig, useLastValidDownPaymentValues } from "./DownPaymentCalculator.utils.esm.js";
import DownPaymentFields from "./DownPaymentFields.esm.js";
const DownPaymentCalculator = ({
  defaultValues
}) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  if (!loaded) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Box, { as: CalculatorForm, fieldStorageKey: "DownPaymentCalculatorFields", calcTypeForMarketing: "DownPayment", editorMode: isEditor(), defaultValues: {
    [FieldConfig.homePrice.name]: 65e4,
    [FieldConfig.other.name]: (defaultValues == null ? void 0 : defaultValues[FieldConfig.percentage.name]) ?? 12,
    [FieldConfig.percentage.name]: 10,
    ...omitUndefined(defaultValues)
  }, sx: {
    paddingBottom: "$spacing.sm",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media $lg": {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingBottom: 0
    }
  }, children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      flex: "1 1 40%",
      padding: "10px",
      paddingBottom: "0px",
      boxSizing: "border-box"
    }, children: /* @__PURE__ */ jsx(DownPaymentFields, {}) }),
    /* @__PURE__ */ jsx(Box, { sx: {
      flex: "1 1 60%",
      padding: "$spacing.xs",
      paddingBottom: "0px",
      boxSizing: "border-box"
    }, children: /* @__PURE__ */ jsxs(Spacer, { style: {
      textAlign: "center"
    }, children: [
      /* @__PURE__ */ jsxs(Heading, { level: "4", marginBottom: "xs", "aria-live": "polite", "aria-atomic": "true", children: [
        "Your down payment amount is:",
        /* @__PURE__ */ jsx(Text, { style: {
          display: "block"
        }, fontType: "h2", fontColor: "green500", margin: "md", children: /* @__PURE__ */ jsx(DownPaymentAmountValue, {}) })
      ] }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Paragraph, { style: {
        margin: "25px"
      }, children: "Based on the home price and down payment percentage, this is the estimated dollar amount you'll need to bring as your down payment, due at closing." }) })
    ] }) })
  ] });
};
const DownPaymentAmountValue = () => {
  const form = useFormContext();
  const values = useLastValidDownPaymentValues(form);
  const downPaymentValue = values.fields.homePrice <= 0 ? 0 : values.fields.homePrice * values.fields.percentage / 100;
  return "$" + commaSeparateNumber(downPaymentValue);
};
export {
  DownPaymentCalculator as default
};
